var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "printcontent" }, [
    _c("div", { ref: "templatePrintBox", staticClass: "printbox" }, [
      _c(
        "div",
        { staticClass: "print" },
        _vm._l(_vm.printboxcode, function(item, index) {
          return _c("div", { key: index, staticClass: "listdome" }, [
            _c("div", { staticClass: "print_cont" }, [
              _c("div", { staticClass: "up" }, [
                _c("div", { staticClass: "ev-code" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(item.serial_number) +
                      " \n              "
                  ),
                  item.provider
                    ? _c("span", { staticClass: "pro-tag" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.provider) +
                            "\n              "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "full_station_name" }, [
                    _vm._v(_vm._s(item.full_station_name))
                  ])
                ]),
                _vm._v(" "),
                item.is_qp == 1
                  ? _c("div", { staticClass: "qp-tag" }, [_vm._v("R4  企拍")])
                  : _c("div", { staticClass: "qp-tag" }, [_vm._v("R4")]),
                _vm._v(" "),
                _c("div", { staticClass: "erwei" }, [
                  _c("img", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { src: item.qrcode, alt: "" }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "xiang-code" }, [
                  _vm._v("\n              箱码: "),
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v(_vm._s(item.box_num))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dan-code" }, [
                  _vm._v("\n              单号:\n              "),
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v(_vm._s(item.main_number))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bian-code" }, [
                  _vm._v("\n              编号:\n              "),
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v(_vm._s(item.supplier_code))
                  ])
                ]),
                _vm._v(" "),
                item.is_qp == 1
                  ? _c("div", { staticClass: "cstm-name" }, [
                      _vm._v(
                        "\n              客户姓名:" +
                          _vm._s(item.cstm_name) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.is_qp == 1
                  ? _c("div", { staticClass: "qp-address" }, [
                      _vm._v(
                        "\n              企拍地址:" +
                          _vm._s(
                            item.logistics_proxy.transportInfo.province +
                              item.logistics_proxy.transportInfo.city +
                              item.logistics_proxy.transportInfo.region +
                              item.logistics_proxy.transportInfo.town
                          ) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isJgj
                  ? _c("div", { staticClass: "other-code" }, [
                      _vm._v(
                        "\n              三方编码:" +
                          _vm._s(item.self_code) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isZhifaOrFactory
                  ? _c("div", { staticClass: "ts-code" }, [
                      _vm._v(
                        "\n              快递单号:" +
                          _vm._s(item.courier_number) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.is_qp == 0
                  ? _c("div", { staticClass: "collect_location zp_order" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.collect_location) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "down" }, [
                _c("div", { staticClass: "table" }, [
                  _c("div", { staticClass: "tr flexcenter" }, [
                    _c("div", { staticClass: "td1" }, [
                      _vm._v("收货方:" + _vm._s(item.recipient))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "td1" }, [
                      _vm._v("联系方式:" + _vm._s(item.mobile))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tr" }, [
                    _c("div", { staticClass: "td2 address-gc" }, [
                      _c("div", [
                        _c("span", [_vm._v("收货地址:")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.address))])
                      ]),
                      _vm._v(" "),
                      Number(item.order_type) == 2
                        ? _c("span", { staticClass: "gc-tag" }, [
                            _vm._v("谷仓")
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              item.last_station_name && item.last_station_name.length <= 7
                ? _c("div", { staticClass: "last-station-name" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(item.last_station_name) +
                        "\n          "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.last_station_name && item.last_station_name.length > 7
                ? _c("div", { staticClass: "last-station-name small" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(item.last_station_name) +
                        "\n          "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.collect_location && item.is_qp == 1
                ? _c("div", { staticClass: "collect_location" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(item.collect_location) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fcfa9f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fcfa9f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/boxcode.vue
// module id = null
// module chunks = 